import * as React from 'react';
import { Copy, Check } from 'lucide-react';
import { Button } from './button';

export interface TotpQrSetupProps {
  qrCodeDataUri: string;
  manualEntryKey: string;
  className?: string;
}

export const TotpQrSetup: React.FC<TotpQrSetupProps> = ({
  qrCodeDataUri,
  manualEntryKey,
  className,
}) => {
  const [copied, setCopied] = React.useState<boolean>(false);

  const copyKey = React.useCallback(async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(manualEntryKey);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard unavailable */
    }
  }, [manualEntryKey]);

  return (
    <div className={`space-y-4 ${className ?? ''}`}>
      <div className="flex flex-col items-center gap-3">
        <div className="rounded-lg border border-border bg-white p-3 shadow-sm">
          <img
            src={qrCodeDataUri}
            alt="QR Code TOTP"
            className="h-44 w-44"
            draggable={false}
          />
        </div>
        <p className="text-xs text-muted-foreground text-center max-w-xs">
          Scansiona con Google Authenticator, Authy, 1Password o app TOTP compatibile.
        </p>
      </div>
      <div className="rounded-lg border border-border bg-muted/40 p-3 dark:bg-white/5">
        <div className="text-[11px] uppercase tracking-wider text-muted-foreground mb-1">
          Oppure inserisci manualmente
        </div>
        <div className="flex items-center gap-2">
          <code className="flex-1 break-all font-mono text-xs text-foreground select-all">
            {manualEntryKey}
          </code>
          <Button
            type="button"
            size="sm"
            variant="ghost"
            onClick={() => { void copyKey(); }}
            className="shrink-0"
            title="Copia chiave"
            aria-label="Copia chiave manuale"
          >
            {copied ? <Check className="h-4 w-4 text-green-600" /> : <Copy className="h-4 w-4" />}
          </Button>
        </div>
      </div>
    </div>
  );
};
